export default "__VITE_ASSET__77853b58__"